import { useRecoilValue } from "recoil";
import { Box, Stack, Typography } from "@mui/joy";
import { paymentOrderAtom } from "recoil/paymentOrderAtom";
import { useTranslation } from "react-i18next";
import usePriceAmount from "hooks/usePriceAmount";

export default function PromotionBanner() {
  const { priceAmount_discount, priceAmount_original } = usePriceAmount();

  const { t: t_payment } = useTranslation("translation", {
    keyPrefix: "payment",
  });
  const paymentOrderState = useRecoilValue(paymentOrderAtom);

  const isDiscount = paymentOrderState?.bannerType === 1;
  const is40000 = paymentOrderState?.bannerType !== 2;

  return (
    <Box
      sx={{
        borderRadius: "12px",
        px: "20px",
        py: "16px",
        backgroundColor: "primary.plainActiveBg",
      }}
    >
      <Stack
        direction={"row"}
        justifyContent="space-between"
        alignItems={"center"}
      >
        <Stack direction={"column"}>
          {isDiscount && (
            <Typography
              level={"body-xs"}
              fontWeight={500}
              sx={{ opacity: 0.5, textDecorationLine: "line-through" }}
            >
              {t_payment("한 달 이용권 n원", { amount: priceAmount_original })}
              {/* {t_payment("월 n원", { amount: priceAmount_original })} */}
            </Typography>
          )}
          <Stack direction={"column"} sx={{ gap: "2px" }}>
            <Typography level={"title-md"} fontWeight={600}>
              {t_payment("한 달 이용권 n원", {
                amount: is40000 ? priceAmount_discount : priceAmount_original,
              })}
              {/* {t_payment("월 n원", {
                amount: is40000 ? priceAmount_discount : priceAmount_original,
              })} */}
            </Typography>
            <Typography level={"body-sm"}>
              {t_payment(
                isDiscount
                  ? `첫 달은 50% 할인된 가격에 이용하세요`
                  : // : `코치와 함께 프로그램을 진행하세요`
                    `한 달 동안 모든 프로그램을 무제한으로 이용하세요`
              )}
            </Typography>
          </Stack>
        </Stack>

        {/* {paymentOrderState.firstMonthOfferLinkIos && (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            sendMessage(
              JSON.stringify({
                event: "open_link",
                params: {
                  url: paymentOrderState.firstMonthOfferLinkIos,
                },
              })
            );
          }}
          sx={{
            backgroundColor: "primary.softColor",
            "&:hover": {
              backgroundColor: "primary.softColor",
              opacity: 0.5,
            },
          }}
        >
          {"할인 쿠폰 받기"}
        </Button>
      )} */}
      </Stack>
    </Box>
  );
}
